import { trackEvent } from './track-event'

export type CartCurrencyProductType = 'experience' | 'accommodation' | 'beach_chair' | 'rentable'

type TrackCartCurrencyMismatchPayload = {
  type: CartCurrencyProductType
  cartCurrency: string
  productCurrency: string
}

export function trackCartCurrencyMismatch({
  type,
  cartCurrency,
  productCurrency,
}: TrackCartCurrencyMismatchPayload) {
  trackEvent({
    event: 'website_message',
    event_name: 'website_message',
    action: 'add_to_cart_blocked',
    type,
    message: 'currency_mismatch',
    cart_currency_mismatch: `${cartCurrency}_${productCurrency}`.toUpperCase(),
  })
}
